import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

interface TimeBoxProps {
  noPadding?: boolean;
}

export const TimeBox = styled(Box).attrs<TimeBoxProps>(
  ({ noPadding = false }) => ({
    pb: noPadding ? 0 : 2,
    align: 'flex-end',
    horizontal: 'true',
  }),
)<TimeBoxProps>``;

export const TimeAgoText = styled(Text).attrs(({ color, size }) => ({
  color: color ? color : 'success',
  size: size,
  pr: 1,
}))``;

export const TimeBoxText = styled(Text).attrs(({ color, size }) => ({
  color: color ? color : 'primaryText',
  size: size ? size : 'xsmall',
}))``;

export const ExtraTime = styled(Text).attrs(({ color, size }) => ({
  color: color ? color : 'secondaryText',
  size: size ? size : 'xsmall',
}))`
  display: inline;
`;
